import '../assets/login.css'
import { OreButton, OreIcon, OreNavBarHeader, SvgNavBarHelp } from '@edenredespana/oreneta'
import { LangSelector } from '../molecules'
import { KebabMenu } from '../molecules'
import { useTranslation } from 'react-i18next'

import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { openNavigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'

export const Navbar = () => {
  const { t } = useTranslation()

  const routesWithLoginSubject = new Set<string>([
    openNavigationRoutes.login,
    openNavigationRoutes.otpAuth,
    openNavigationRoutes.registerStepOne,
    openNavigationRoutes.registerStepTwo,
    openNavigationRoutes.registerStepThree,
    openNavigationRoutes.registerEmailSuccess,
    openNavigationRoutes.passwordRecoveryStep1,
    openNavigationRoutes.passwordRecoveryStep2,
    openNavigationRoutes.passwordRecoveryEmailSuccess,
    openNavigationRoutes.passwordRecoveryPasswordChangeSuccess,
    openNavigationRoutes.passwordRecoveryPasswordChangeError,
    openNavigationRoutes.otp
  ])

  const handleHelpClick = () => {
    const currentPath = globalThis.location.pathname
    const includeSubject = routesWithLoginSubject.has(currentPath)

    const mailtoBase = `mailto:${import.meta.env.VITE_CONTACT_EMAIL}`
    const mailtoUrl = includeSubject
      ? `${mailtoBase}?subject=${t(LoginTranslation.navbar.mailtoButton.subject)}`
      : mailtoBase
    globalThis.location.href = mailtoUrl
  }

  return (
    <OreNavBarHeader>
      <OreButton onClick={handleHelpClick} category="tertiary">
        <OreIcon tone={'ternary'} size={'extra-small'} icon={<SvgNavBarHelp />} />
      </OreButton>
      <LangSelector />
      <div className="navbar-divider"></div>
      <KebabMenu />
    </OreNavBarHeader>
  )
}
